import styled from 'styled-components';

const ProductItemStyleStyle = styled.div`
	--sizeImage: 28.7vw;
	--radiusImage: var(--sp3x);
	--distanceTitleImage: var(--sp5x);
	--distanceDescriptionTitle: var(--sp3x);
	--buttonPadT: var(--sp4x);

	--sizeHome: 34.4vw;

	.wrapper-all {
		transition: var(--trTime) ease-out;
	}

	.product-item-image-wrapper {
		height: var(--sizeImage) !important;
		position: relative;

		.image-cont {
			--proportion: 0;

			height: var(--sizeImage) !important;
			display: flex;
			justify-content: center;
			align-items: flex-start;
			width: 100% !important;
			background-color: var(--gray1000) !important;
			transition: height var(--trTime) ease-out;
			border-radius: var(--radiusImage);
			overflow: hidden;

			img {
				position: relative !important;
				object-fit: cover !important;
				transform: scale(1.1);
				transform-origin: top bottom !important;
				border-radius: var(--radiusImage);
				will-change: transform;
				min-height: 100%;
				/* max-height: fit-content !important; */
				transition: var(--trTime) ease-out;
			}
		}
	}

	.material-item-info-wrapper {
		background-color: var(--lightGray1000);
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		.title {
			padding-top: var(--distanceTitleImage);
		}

		.description {
			padding-top: var(--distanceDescriptionTitle);
		}

		.wrapper-button {
			position: absolute;
			bottom: 0%;
			padding-top: var(--buttonPadT);
		}

		.inner-wrapper-button {
			transition: calc(var(--trTime) / 2) ease-out;
			transform-origin: center center;
			transform: scale(0);
		}

		.wrapper-text-outside {
			display: flex;
			flex-direction: column;
			align-items: center;
			transform: translateY(0);
			transition: var(--trTime) ease-out;
		}

		p {
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				.wrapper-all {
					/* transform: translateY(calc(-4%)); */
				}

				.wrapper-text-outside {
					transform: translateY(calc(var(--buttonHeight) * -1));
				}

				.inner-wrapper-button {
					transition: var(--trTime) ease-in-out;
					transform: scale(1);
					transition-delay: 100ms;
				}

				.image-cont {
					height: calc(100% - var(--buttonHeight)) !important;

					img {
						transform: scale(1);
					}
				}
			}
		}
	}

	&.no-hover {
		--sizeImage: var(--sizeHome);

		svg {
			position: absolute;
			top: 0;
			left: 19.2%;

			width: 70%;
			height: 100%;
			fill: none;
		}

		img {
			transform: scale(1) !important;
		}
		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					.wrapper-all {
						transform: translateY(0);
					}

					.wrapper-text-outside {
						transform: translateY(0);
					}

					.inner-wrapper-button {
						transform: scale(0);
					}

					.image-cont {
						height: calc(100%) !important;

						img {
							transform: scale(1);
						}
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--buttonPadT: var(--sp3x);
		--sizeImage: 29.7vw;
		--radiusImage: var(--sp2x);
		--distanceTitleImage: var(--sp4x);
		--distanceDescriptionTitle: var(--sp2x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--buttonPadT: 18px;
		--sizeImage: 27.5vw;
		--radiusImage: var(--sp2x);
		--distanceTitleImage: var(--sp4x);
		--distanceDescriptionTitle: var(--sp2x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 27.8vw;
		--radiusImage: var(--sp2x);
		--distanceTitleImage: var(--sp3x);
		--distanceDescriptionTitle: var(--sp1-5x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--buttonPadT: var(--sp2x);
		--sizeImage: 33.6vw;
		--radiusImage: var(--sp2x);
		--distanceTitleImage: var(--sp3x);
		--distanceDescriptionTitle: var(--sp1-5x);

		--sizeHome: 33.35vw;
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeImage: 32.8vw;
		--radiusImage: var(--sp2x);
		--distanceTitleImage: var(--sp2x);
		--distanceDescriptionTitle: var(--sp1-5x);

		--sizeHome: 32.6vw;
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--sizeImage: 33vw;
		--radiusImage: var(--sp1x);
		--distanceTitleImage: var(--sp1-5x);
		--distanceDescriptionTitle: var(--sp1x);

		--sizeHome: 38.6vw;
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeImage: 100vw;
		--radiusImage: var(--sp1x);
		--distanceTitleImage: var(--sp1-5x);
		--distanceDescriptionTitle: var(--sp1x);

		--sizeHome: 116.2vw;
	}
`;
export default ProductItemStyleStyle;
